module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-779-min.72b03420.jpg";